<template>
  <div>
    <ProductHeader title="Detalle de Producto"/>
    <ProductForm :product="product" @onUpdate="onUpdate"/>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import ProductHeader from '../ProductHeader'
import ProductForm from '../ProductForm'

export default {
  name: 'ProductDetail',
  components: {
    ProductHeader,
    ProductForm
  },
  props: {
    productId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      product: {}
    }
  },
  created () {
    this.loadProductData()
  },
  methods: {
    ...mapMutations([
      'toggleProductBtnLoading'
    ]),
    ...mapActions([
      'getProductDetail',
      'updateProductDetail',
      'deleteProduct',
      'setAlertData'
    ]),
    loadProductData () {
      this.getProductDetail(this.productId)
        .then((res) => {
          if (res.exists) {
            this.product = { ...res.data(), id: res.id }
          } else {
            console.log('[getProductDetail]', '404 Not Found', 'Redirecting...')
            // this.$router.push({ name: 'Products' })
          }
        })
        .catch((err) => {
          console.log('[getProductDetail]')
          console.log(err)
        })
    },
    onUpdate (data) {
      this.toggleProductBtnLoading(true)
      data.updatedAt = new Date().getTime()
      this.updateProductDetail(data)
        .then(() => {
          window.scrollTo(0, 0)
          this.toggleProductBtnLoading(false)
          this.setAlertData({
            visible: true,
            msg: 'Producto Actualizado 🥳',
            type: 'success'
          })
        })
        .catch((err) => {
          this.toggleProductBtnLoading(false)
          console.log('[updateProductDetail]')
          console.log(err)
        })
    }
  }
}
</script>
